export class UtilAreaNaoLogada {

    static caminhos() : Array<string>{
        return [
            "/",
            "/conheca-seus-direitos",
            "/como-tratamos-seus-dados",
            "/entenda-as-finalidades-de-uso",
            "/como-protegemos-seus-dados",
            "/gerenciar-preferencias",
            "/autenticacao",
            "/direcionamento-de-ofertas",
            "/direitos-de-correcao"

        ];
      }

}